import { loadStripe } from "@stripe/stripe-js";
import DialerTreeConfig from "@/app/config";
import { toast } from "sonner";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import React from "react";

interface ExistingCardPaymentProps {
  amount: number;
  clientSecret: string;
  selectedPaymentMethodId: string;
  onSuccess: () => void;
}

export function ExistingCardPayment({
  amount,
  clientSecret,
  selectedPaymentMethodId,
  onSuccess,
}: ExistingCardPaymentProps) {
  const stripe = loadStripe(DialerTreeConfig.stripePublishableKey);
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePayWithExistingCard = async () => {
    setIsProcessing(true);

    try {
      const stripeInstance = await stripe;
      if (!stripeInstance) {
        throw new Error("Stripe not loaded");
      }

      const { error } = await stripeInstance.confirmCardPayment(clientSecret, {
        payment_method: selectedPaymentMethodId,
      });

      if (error) {
        toast.error(error.message);
        setIsProcessing(false);
      } else {
        toast.success("Your credits have been added");
        setTimeout(async () => {
          setIsProcessing(false);
          onSuccess();
        }, 2000);
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to process payment");
      setIsProcessing(false);
    }
  };

  return (
    <Button onClick={handlePayWithExistingCard} disabled={isProcessing} className="w-full">
      {isProcessing ? "Processing..." : `Pay $${amount.toFixed(2)}`}
    </Button>
  );
}
